export class NullishError extends Error {
  readonly name = "NullishError" as const;
}